import React from "react";
import { useTranslation } from "react-i18next";
import Card from "../generic/Card";

function CriteriaSection() {
  const { t } = useTranslation();

  const criteria = [
    {
      id: "criteria1",
      icon: "fas fa-bullseye",
      title: t("taolu_criteria.criteria1.title"),
      description: t("taolu_criteria.criteria1.description"),
    },
    {
      id: "criteria2",
      icon: "fas fa-balance-scale",
      title: t("taolu_criteria.criteria2.title"),
      description: t("taolu_criteria.criteria2.description"),
    },
    {
      id: "criteria3",
      icon: "fas fa-fire",
      title: t("taolu_criteria.criteria3.title"),
      description: t("taolu_criteria.criteria3.description"),
    },
    {
      id: "criteria4",
      icon: "fas fa-water",
      title: t("taolu_criteria.criteria4.title"),
      description: t("taolu_criteria.criteria4.description"),
    },
  ];

  return (
    <section
      className="relative z-10 bg-slate-50/50 pb-14 pt-12 transition-colors dark:bg-slate-900 md:pb-16 md:pt-14"
      id="criteria-section"
      aria-labelledby="taolu-criteria-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <header className="mb-10 text-center md:mb-12">
          <h2
            id="taolu-criteria-heading"
            className="relative mb-5 inline-block text-4xl font-semibold tracking-tight text-primary dark:text-primary-light md:text-5xl"
          >
            {t("taolu_criteria.title")}
            <span
              className="absolute -bottom-2.5 left-1/2 h-0.5 w-16 -translate-x-1/2 rounded-full bg-primary dark:bg-primary-light"
              aria-hidden
            />
          </h2>
          <p className="mx-auto mt-5 max-w-3xl text-pretty text-lg leading-relaxed text-slate-600 dark:text-slate-400">
            {t("taolu_criteria.intro")}
          </p>
        </header>

        <ul className="m-0 grid list-none grid-cols-1 gap-5 p-0 sm:grid-cols-2 md:gap-6 xl:grid-cols-4">
          {criteria.map((item) => (
            <li key={item.id} className="min-h-0">
              <Card
                icon={item.icon}
                title={item.title}
                description={item.description}
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default CriteriaSection;
